<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/POA/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>